//File to display login screen, on successful login display project management dashboard
import React, { useState } from 'react';
import {
  TextField,
  Button,
  Typography,
  Container,
  Box,
  Grid,
  IconButton,

} from '@mui/material';
import axios from 'axios';
import { ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import getTheme from '../theme/theme';
import { Link as RouterLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import { setUser } from '../store/subscription/Action';
import { BASEURL, AUTOFILL_STYLES } from '../constants/Common';
import { Backdrop, CircularProgress, } from "@mui/material";
import { Visibility, VisibilityOff } from '@mui/icons-material';

interface LoginProps {
  onLogin: (token: string) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const theme = getTheme();
  const dispatch = useDispatch();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  //  const [error, setError] = useState('');
  //  const [loginSuccess, setLoginSuccess] = useState(false);
  //  const [idfield, setIdField] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isButtonVisible, setIsButtonVisible] = useState(true);

  const navigate = useNavigate();

  const handleSubmit = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    try {
      setIsLoading(true);
      setIsButtonVisible(false); // Hide the button when clicked
      const response = await axios.post(BASEURL + '/token/', {
        username,
        password,
      });
      // console.log("response:",response);
      const token = response.data.access;
      localStorage.setItem('authToken', token);
      const responsetoken = await axios.get<{
        user: {
          id: number; organization_id: number;
          email: string; username: string; user_role: string; is_active: boolean;
        }, subscription_plan: { features: [] } | null;
      }>(
        BASEURL + '/user-details/',
        {
          headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
            'Content-Type': 'application/json',
          },
        }
      );

      if (!responsetoken.data.user.is_active) {
        throw new Error('inactive_account');
      }

      // setIdField(responsetoken.data.user.id) 
      const emailusername = responsetoken.data.user.username
      const userId = responsetoken.data.user.organization_id
      const authid = responsetoken.data.user.id
      const userRole = responsetoken.data.user.user_role
      const eMail = responsetoken.data.user.email
      const pricingfeatures = responsetoken.data.subscription_plan?.features || [];

      console.log("authid:", authid);
      localStorage.setItem('orgid', JSON.stringify(responsetoken.data.user.organization_id));

      fetchUserRole(username);
      localStorage.setItem('featuresDetails', JSON.stringify(pricingfeatures));
      localStorage.setItem('email', JSON.stringify(eMail));
      localStorage.setItem('userRoleAdmin', JSON.stringify(userRole));
      localStorage.setItem('authData', JSON.stringify(authid));
      localStorage.setItem('username', username);



      dispatch(setUser(userId));
      onLogin(token);
      //     setLoginSuccess(true);

      navigate('/verifyemail')

      if (response.status === 200) {
        // Check if response is defined

        //toast.success('User login successful');
      }
      // window.location.reload();
    } catch (error) {
      console.log("error:", error);
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 401) {
          toast.error('Invalid login credentials');
        } else if (error.response?.status === 403) {
          toast.error('Too many failed login attempts. Please try again after sometime.');
        } else if (error.message === 'inactive_account') {
          toast.error('Please activate your account using the confirmation mail.');
        } else if (error.code === 'ECONNABORTED' || error.message === 'Network Error') {
          toast.error('Server error. Please try after some time');
        } else {
          toast.error('Login failed. Please try again.');
        }
      } else {
        toast.error('An unexpected error occurred. Please try again.');
      }
    } finally {
      setIsLoading(false);
      setIsButtonVisible(true);
    }
  };

  const fetchUserRole = async (username: any) => {
    //To fetch user role id from users_users table for the user logged in.
    try {

      const roleid_url = BASEURL + '/users/userroleid/' + username;
      const response = await axios.get(roleid_url, {
        headers: { Accept: 'application/json', },
      });
      const roleid_data = response.data;

      if (roleid_data) {
        localStorage.setItem('userid', JSON.stringify(roleid_data.user_id));
        localStorage.setItem('roleid', JSON.stringify(roleid_data.user_role_id));
        //Below userdetails will have - projectaccess, scheduleaccess, modulesaccess, reportsaccess, status
        localStorage.setItem('userrole', JSON.stringify(roleid_data.userdetails));
        localStorage.setItem('usercategory', JSON.stringify(roleid_data.user_category));

      }
    } catch (error) {
      console.log("Error in fetching roleid " + error);
    }

  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };


  return (
    <ThemeProvider theme={getTheme()}>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color='inherit' />
      </Backdrop>


      <Container component='main' maxWidth='xs'>
        <Box
          sx={{
            marginTop: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginLeft: 5,
            marginRight: 5,
          }}
        >
          <Typography component='h1' variant='h5'>
            Login Authentication
          </Typography>
          <Box component='form' noValidate sx={{ mt: 1 }}>
            <TextField
              margin='normal'
              required
              fullWidth
              id='username'
              label='Username'
              name='username'
              autoComplete='username'
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              sx={{
                height: '20px',
                marginBottom: 4,
                ...AUTOFILL_STYLES(theme),
                // '& .MuiInputLabel-root': {
                //   color: 'black', // Change the color of the floating label to black
                // },
                // '& .MuiInputBase-input': {
                //   color: 'black', // Change the color of the text input to black
                // },
                // '& .MuiOutlinedInput-root': {
                //   '& fieldset': {
                //     borderColor: 'black', // Change the border color of the text field
                //   },
                //   '&:hover fieldset': {
                //     borderColor: 'black', // Change the border color on hover
                //   },
                //   '&.Mui-focused fieldset': {
                //     borderColor: 'black', // Change the border color when focused
                //   },
                // },
                // '& .MuiInputLabel-root.Mui-focused': {
                //   color: 'black', // Change the color of the floating label when focused to black
                // },
              }}
            />

            <TextField
              margin='normal'
              required
              fullWidth
              name='password'
              type={showPassword ? 'text' : 'password'} // Show password if showPassword is true
              label='Password'
              id='password'
              autoComplete='current-password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={togglePasswordVisibility}
                    edge='end'
                  >
                    {!showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                ),
              }}
              sx={{
                height: '20px',
                marginBottom: 4,
                ...AUTOFILL_STYLES(theme),
              }
              }
            />

            <Button type='submit' fullWidth variant='contained' sx={{ mt: 3, mb: 2, '&:disabled': { bgcolor: 'grey.400', color: 'grey.700' } }}
              onClick={handleSubmit}
              disabled={!isButtonVisible}
            >
              Sign In
            </Button>

            <Grid container justifyContent={'flex-end'}>
              <Grid item>
                {/* <Link to='/register' style={{ color: 'red' }}>
                  Don't have an account? Register
                </Link> */}
                <RouterLink
                  to='/register'
                  style={{
                    padding: '6px', color: 'inherit',
                    cursor: 'pointer', // Set the cursor to pointer style
                  }}
                >
                  Don't have an account? Register
                </RouterLink> <br />

              </Grid>
            </Grid>
            <Grid container justifyContent={'flex-end'}>
              <Grid item>
                {/* <Link to='/resetpassword' style={{ color: 'red' }}>
                  Forgot Password
                </Link> */}
                {/* <ButtonBase component={Link} to='/resetpassword' style={{padding: '6px' }}>
      Forgot Password
    </ButtonBase> */}
                <RouterLink
                  to='/resetpassword'
                  style={{
                    padding: '16px 6px', // Increase padding to create a larger clickable area
                    color: 'inherit',
                    cursor: 'pointer',
                    display: 'inline-block', // Ensure link behaves like a block element
                  }}
                >
                  Forgot Password?
                </RouterLink>

                {/* <RouterLink
        to='/resetpassword'
        style={{
          padding: '6px',  color: 'inherit',
         
      }}
      >
        test
      </RouterLink> */}

              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default Login;
